import { createIcon } from '../createIcon.tsx';

export const SettingsIcon = createIcon(
	'SettingsIcon',
	<>
		<circle cx="12" cy="12" r="3" />
		<path d="M12 1v6m0 6v6m-5.196-2.804l4.242 4.242m0-8.485L6.804 6.804M1 12h6m6 0h6m-2.804 5.196l-4.242-4.242m0 0L6.804 17.196" />
	</>,
);
